/**
 * CSV export of the rows the API sent, as they are: the admin app's tables (ADR 0016), the garage's expenses. RFC 4180
 * quoting, a byte-order mark so spreadsheets read UTF-8, and text that a spreadsheet would run as
 * a formula (=, +, -, @) defused with a leading apostrophe: garage names are typed by people.
 */

export type CsvValue = string | number | boolean | null | undefined;

function cell(value: CsvValue): string {
  if (value === null || value === undefined) return "";
  if (typeof value !== "string") return String(value);
  const text = /^[=+\-@\t\r]/.test(value) ? `'${value}` : value;
  return /[",\r\n]/.test(text) ? `"${text.replaceAll('"', '""')}"` : text;
}

export function toCsv(header: readonly string[], rows: readonly (readonly CsvValue[])[]): string {
  return `﻿${[header, ...rows].map((row) => row.map(cell).join(",")).join("\r\n")}\r\n`;
}

/** Saves the rows as `<name>.csv`. */
export function downloadCsv(
  name: string,
  header: readonly string[],
  rows: readonly (readonly CsvValue[])[],
): void {
  const url = URL.createObjectURL(new Blob([toCsv(header, rows)], { type: "text/csv" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = `${name}.csv`;
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
